<template>
  <v-main v-if="!currentUser.is_student">
    <v-row v-if="test" class="test-info">
      <v-col cols="6" class="test-details">
        <h2>{{ test.tname }}</h2>
        <h4>{{ test.subject.name }}</h4>
        <h4>{{ test.subject.room.sections }}</h4>
        <p class="description-text">{{ startDateTime }} - {{ endDateTime }}</p>
      </v-col>
      <v-col cols="6" class="align-end">
        <p>
          <v-btn :to="`/test/${$route.params.tid}/cheating`">Cheating Data</v-btn>
        </p>
        <p></p>
        <p>
          <v-btn @click="createPDF" color="primary">Download</v-btn>
        </p>
      </v-col>
    </v-row>
    <v-card class="result_students">
      <v-card-title>
        Test Results: {{ students.length }} Students
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        ref="statsTable"
        class="row-pointer"
        :headers="headers"
        :items="students"
        :search="search"
        @click:row="handleClick"
        :items-per-page="-1"
      >
        <template v-slot:item.srno="{ item }">
          <span>{{ students.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:item.full_name="{ item }" class="text-center">
          <span v-if="item.student">{{ item.student.full_name }}</span>
          <span v-if="item">{{ item.full_name }}</span>
          <!-- <span><i class="fas fa-times" v-if="!item.correct"></i></span> -->
        </template>
        <template v-slot:item.phone="{ item }" class="text-center">
          <span v-if="item.student">{{ item.student.phone }}</span>
          <span v-else>{{ item.phone }}</span>
          <!-- <span><i class="fas fa-times" v-if="!item.correct"></i></span> -->
        </template>
        <template v-slot:item.score="{ item }" class="text-center">
          <span v-if="item.scored != null && item.total != null">{{ item.scored }} / {{ item.total }}</span>
          <span v-else color="red">-</span>
          <!-- <span><i class="fas fa-times" v-if="!item.correct"></i></span> -->
        </template>
        <template v-slot:item.v_result="{ item }">
          <v-btn v-if="item.scored != null && item.total != null" color="primary">View Result</v-btn>
          <div v-else class="text-red">Not Attempted</div>
        </template>
      </v-data-table>
    </v-card>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import testsApi from "@api/tests/all_tests";
import Helper from "@utils/misc";
import moment from "moment";

import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "TestStats",
  data() {
    return {
      search: "",
      test: null,
      headers: [
        { text: "Sr. No", value: "srno" },
        {
          text: "Student",
          align: "start",
          sortable: false,
          value: "full_name"
        },
        { text: "Phone", value: "phone" },
        { text: "Score", value: "score" },
        { text: "", value: "v_result", align: "center", sortable: false }
      ],
      students: [],
      nonTestStudents: []
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    // gets the test details for displaying
    async getTestDetails() {
      this.setLoading(true);
      // gets test details
      let testFromServer = await testsApi.getTestDetails(
        this.accessToken,
        this.$route.params.tid
      );
      console.log(testFromServer);
      if (!Helper.handleErrors(testFromServer, this.handleErrors)) return;
      // display
      this.test = testFromServer;
      this.setLoading(false);
    },

    // get test stats from server
    async getTestStatsFromServer() {
      this.setLoading(true);
      let statsFromServer = await testsApi.getAllResultsFromServer(
        this.accessToken,
        this.$route.params.tid
      );
      if (!Helper.handleErrors(statsFromServer, this.handleErrors)) return;
      this.students = statsFromServer.test_givers;
      this.students.push(...statsFromServer.non_givers);
      console.log(this.students);
      this.setLoading(false);
    },
    // routes to individual reports

    handleClick(value) {
      if (value.student) {
        this.$router.push(
          "/test/" +
            this.$route.params.tid +
            "/stats/student/" +
            value.student.id
        );
      }
    },
    handleErrors(err) {
      console.log(err);
      if (err.response.status == 405) {
        this.$router.push("/restricted");
      }
    },
    createPDF() {
      this.setLoading(true);
      var source = this.$refs["statsTable"];
      let rows = [];
      let columnHeader = ["Student", "Phone", "Score"];
      let pdfName = `Result_${this.test.tname}`;
      source.items.forEach(element => {
        var temp =
          element.student == null
            ? [element.full_name, element.phone, `NOT ATTEMPTED`]
            : [
                element.student.full_name,
                element.student.phone,
                `${element.scored}/${element.total}`
              ];
        rows.push(temp);
      });
      var doc = new jsPDF();

      // Stats header
      let detailsHeader = ["Test Name", "Subject", "Test Date", "Teacher"];
      var detailRow = [
        this.test.tname,
        `${this.test.subject.name}-${this.test.subject.room.sections}`,
        `${this.startDateTime}-${this.endDateTime}`,
        this.test.created_by.full_name
      ];
      doc.autoTable(detailsHeader, [detailRow], {
        startY: 10,
        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] }
      });

      doc.autoTable(columnHeader, rows, { startY: 30 });
      doc.save(pdfName + ".pdf");
      this.setLoading(false);
    }
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    startDateTime: function() {
      var d = new Date(this.test.start_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    },
    endDateTime: function() {
      var d = new Date(this.test.end_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    }
  },
  created() {
    if (this.currentUser.is_student) return;
    this.getTestDetails();
    this.getTestStatsFromServer();
  }
};
</script>

<style scoped>
.result_students {
  max-width: 90%;
  margin-right: 5%;
  margin-left: 5%;
}

.test-info {
  padding-right: 5%;
  margin-left: 5%;
  margin-top: 15px;
}

.align-end {
  text-align: end;
}
.test-description {
  padding: 10px;
  padding-left: 30px;
  border-top: 5px solid #009688;
  border-radius: 20px;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.text-red {
  color: red;
}
.test-details{
    word-break: break-word;
}
</style>